import { RelatorioService } from '@app/services/relatorio.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
// import { AutocompleteDataService } from '@app/services/autocomplete.service';
import { UsuarioService } from '@app/services/usuario.service';
import { FiltroRelatorioMeAvise, MeAviseRelatorio } from './me-avise-relatorio';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-me-avise',
  templateUrl: './relatorio-me-avise.component.html'
})
export class RelatoriosMeAviseComponent implements OnInit {

  relatorioMeAvise: MeAviseRelatorio[] = [];

  showTable: boolean = false;
  pesquisando: boolean = false;
  // participanteDataService: AutocompleteDataService;
  consultarOutrosUsuariosMeAvise = false;

  lstFuncionarios: Array<IdDescricao>[] = [];
  lstUsuariosTransferencia: Array<IdDescricao>[] = [];

  filtros: FiltroRelatorioMeAvise = <FiltroRelatorioMeAvise>{
    somenteNaoRealizadas: true,
    dataInicial: '',
    dataFinal: '',
    funcionarioSelecionado: 0
  };

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    private usuarioService: UsuarioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    this.usuarioService.obterUsuarioLogado().toPromise().then(usuarioLogado => {
      this.filtros.funcionarioSelecionado = usuarioLogado;
      this.consultasService.consultar('USUARIO_APELIDO_E_NOMEFANTASIA').toPromise().then(data => {
        this.lstUsuariosTransferencia = data.filter((x: any) => x.Id !== usuarioLogado);
        this.lstFuncionarios = data;
      });
    });
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    this.obterTodos();
  }

  obterTodos() {
    this.relatorioService.meAviseRelatorio(this.filtros)
      .toPromise().then((data: MeAviseRelatorio[]) => {
        this.relatorioMeAvise = data;
        this.pesquisando = false;
        this.preencheAtraso(this.relatorioMeAvise);
        this.formatarDados(this.relatorioMeAvise);

        if (this.relatorioMeAvise.length === 0) {
          this.showTable = false;
          this.toastr.info("Busca não encontrou resultados");
        } else {
          this.showTable = true;
        }
      }, erro => {
        this.pesquisando = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      })
    //  () => this.pesquisando = false);
  }

  formatarDados(relatorio: MeAviseRelatorio[]): void {
    relatorio.forEach(item => {
      if (new Date(item.DataFinal).getFullYear() == 1) {
        item.DataFinal = "";
      }
    })
  }

  preencheAtraso(relatorio: MeAviseRelatorio[]) {
    const hoje = new Date();
    relatorio.forEach(
      item => {
        if (new Date(item.DataFinal).getFullYear() == 1) {
          item.Atraso = "";
        } else {
          const atraso = Math.ceil(Math.abs(hoje.getTime() - (new Date(item.DataFinal)).getTime()) / (1000 * 3600 * 24));
          item.Atraso = atraso > 1 ? `${atraso} dias` : (atraso === 1 ? '1 dia' : 'Hoje');
        }
      });
  }

  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("relatorioMeAvise").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatorio Me Avise", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    adicionaMapValido('Somente não realizaos', this.filtros.somenteNaoRealizadas ? 'Sim' : 'Não')
    
    parseDateAdicionaMap('Inserção Inicial', this.filtros.dataInicial);
    parseDateAdicionaMap('Inserção Final', this.filtros.dataFinal);


    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }
}
